export function LogoSimple({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      id="Réteg_1"
      data-name="Réteg 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 509.52 73.43"
    >
      <defs>
        <style>{`.cls-1{fill:#36c799;}.cls-2{fill:#2e2d2c;}`}</style>
      </defs>
      <title>ACCURE-logo-positive-color-claim</title>
      <rect className="cls-1" x="0.02" y="50.96" width="7.22" height="7.22" />
      <rect className="cls-1" x="0.02" y="22.07" width="7.22" height="7.22" />
      <rect className="cls-1" x="7.23" y="14.87" width="7.22" height="7.22" />
      <rect className="cls-1" y="0.43" width="7.22" height="7.22" />
      <rect className="cls-1" x="14.45" y="22.09" width="7.22" height="7.22" />
      <rect
        className="cls-1"
        x="56.76"
        y="0.55"
        width="27"
        height="72"
        rx="2.98"
      />
      <rect
        className="cls-1"
        x="93.39"
        y="0.56"
        width="27"
        height="72"
        rx="2.98"
      />
      <path
        className="cls-1"
        d="M195.08,261.36v7.22h-7.22v-7.22h-7.24v7.22h0v7.22h7.21V283h7.22v7.21h-7.22v7.25h-14.4v7.22h7.22v7.21h7.21v7.22h7.22v7.21h-7.22v-7.21h-7.21v7.21h-7.22v7.22h36.91a3,3,0,0,0,3-3V264.34a3,3,0,0,0-3-3Zm7.22,50.52h-7.22v-7.21h7.22Z"
        transform="translate(-166.19 -260.92)"
      />
      <path
        className="cls-2"
        d="M354.27,332.27l-3.59-11.48c-.14-.27-.31-.41-.51-.41h-28.6c-.2,0-.38.14-.51.41l-3.59,11.48a1.67,1.67,0,0,1-1.74,1.23h-7.28q-1.74,0-1.23-1.74L329.36,263a1.68,1.68,0,0,1,1.74-1.23h9.43a1.69,1.69,0,0,1,1.75,1.23l22.34,68.78a1.4,1.4,0,0,1,.1.61c0,.76-.44,1.13-1.33,1.13H356A1.67,1.67,0,0,1,354.27,332.27Zm-30.14-19.68h23.48c.41,0,.54-.2.41-.61l-11.89-38.23c-.07-.28-.18-.41-.31-.41s-.24.13-.31.41L323.72,312c-.07.41.07.61.41.61Z"
        transform="translate(-166.19 -260.92)"
      />
      <path
        className="cls-2"
        d="M385.07,331.48a21,21,0,0,1-8.82-8.3,24.05,24.05,0,0,1-3.12-12.35V284.3a23.6,23.6,0,0,1,3.12-12.25,21.39,21.39,0,0,1,8.82-8.2,28.31,28.31,0,0,1,13.07-2.92,28.81,28.81,0,0,1,13,2.82,21.17,21.17,0,0,1,8.77,7.95A22.38,22.38,0,0,1,423,283.59q0,1-1.53,1.23l-6.77.41h-.41a1.46,1.46,0,0,1-.82-.21c-.2-.14-.31-.27-.31-.41V284a14,14,0,0,0-4.06-10.52q-4.11-4-11-4t-11,4A14,14,0,0,0,383,284v27.26a14,14,0,0,0,4.15,10.56q4.14,4,11,4t11-4a14.1,14.1,0,0,0,4.1-10.56,1.07,1.07,0,0,1,.41-.92,1.5,1.5,0,0,1,1.13-.21l6.77.41q1.53.21,1.53.51v.52a22.75,22.75,0,0,1-3.17,11.91,21.28,21.28,0,0,1-8.77,8,30.82,30.82,0,0,1-26.08-.05Z"
        transform="translate(-166.19 -260.92)"
      />
      <path
        className="cls-2"
        d="M447.28,331.48a21,21,0,0,1-8.81-8.3,24,24,0,0,1-3.13-12.35V284.3a23.49,23.49,0,0,1,3.13-12.25,21.36,21.36,0,0,1,8.81-8.2,28.44,28.44,0,0,1,13.07-2.92,28.81,28.81,0,0,1,13,2.82,21.08,21.08,0,0,1,8.76,7.95,22.37,22.37,0,0,1,3.13,11.89c0,.68-.51,1.09-1.54,1.23l-6.76.41h-.41a1.38,1.38,0,0,1-.82-.21c-.21-.14-.31-.27-.31-.41V284a14.1,14.1,0,0,0-4.1-10.56q-4.11-4-11-4t-11,4A14,14,0,0,0,445.15,284v27.26a14,14,0,0,0,4.15,10.56q4.15,4,11,4t11-4a14.1,14.1,0,0,0,4.1-10.56,1,1,0,0,1,.41-.92,1.5,1.5,0,0,1,1.13-.21l6.76.41c1,.14,1.54.31,1.54.51v.52a22.63,22.63,0,0,1-3.11,11.91,21.2,21.2,0,0,1-8.76,8,30.84,30.84,0,0,1-26.09-.05Z"
        transform="translate(-166.19 -260.92)"
      />
      <path
        className="cls-2"
        d="M510.83,331.4a21.3,21.3,0,0,1-8.86-8.3,23.77,23.77,0,0,1-3.18-12.35V263.29a1.47,1.47,0,0,1,.41-1.13,1.55,1.55,0,0,1,1.13-.41h6.76a1.42,1.42,0,0,1,1.54,1.29V311a14.29,14.29,0,0,0,4.25,10.77A15.33,15.33,0,0,0,524,325.81q6.87,0,11.07-4.09a14.42,14.42,0,0,0,4.2-10.77V263.29a1.42,1.42,0,0,1,1.29-1.54h7a1.42,1.42,0,0,1,1.53,1.54v47.46A24.24,24.24,0,0,1,546,323.1a21.2,21.2,0,0,1-8.82,8.3,31.18,31.18,0,0,1-26.34,0Z"
        transform="translate(-166.19 -260.92)"
      />
      <path
        className="cls-2"
        d="M604.77,332.37,590.63,302a.68.68,0,0,0-.62-.41H575.56a.45.45,0,0,0-.51.38.29.29,0,0,0,0,.13V332a1.54,1.54,0,0,1-.41,1.12,1.5,1.5,0,0,1-1.13.41h-6.77a1.42,1.42,0,0,1-1.53-1.53V263.19a1.42,1.42,0,0,1,1.29-1.54h27.3a22.16,22.16,0,0,1,10.82,2.56,18.07,18.07,0,0,1,7.22,7.18,21.64,21.64,0,0,1,2.56,10.66,19.3,19.3,0,0,1-3.79,12,18.5,18.5,0,0,1-10.25,6.71.52.52,0,0,0-.31.62l14.56,30.24.2.82c0,.68-.44,1-1.33,1h-7A1.76,1.76,0,0,1,604.77,332.37Zm-29.72-61.7v22.75c0,.35.16.52.51.52h17a11.81,11.81,0,0,0,8.66-3.28,11.45,11.45,0,0,0,3.33-8.51,11.28,11.28,0,0,0-10.49-12,12.68,12.68,0,0,0-1.51,0h-17a.46.46,0,0,0-.51.39.57.57,0,0,0,0,.13Z"
        transform="translate(-166.19 -260.92)"
      />
      <path
        className="cls-2"
        d="M675.29,269.85a1.58,1.58,0,0,1-1.13.41H638.39a.45.45,0,0,0-.51.38.29.29,0,0,0,0,.13v21.84a.44.44,0,0,0,.38.51h24.52a1.42,1.42,0,0,1,1.54,1.29v5.68a1.42,1.42,0,0,1-1.54,1.54H638.39a.45.45,0,0,0-.51.38.29.29,0,0,0,0,.13v22.34a.44.44,0,0,0,.38.51h35.9a1.42,1.42,0,0,1,1.54,1.29V332a1.54,1.54,0,0,1-.41,1.12,1.5,1.5,0,0,1-1.13.41H629.57a1.42,1.42,0,0,1-1.53-1.3.89.89,0,0,1,0-.23V263.29a1.47,1.47,0,0,1,.41-1.13,1.53,1.53,0,0,1,1.12-.41h44.59A1.42,1.42,0,0,1,675.7,263v5.68A1.55,1.55,0,0,1,675.29,269.85Z"
        transform="translate(-166.19 -260.92)"
      />
    </svg>
  );
}
